import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "mas fw-light" }, "refresh", -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_ProductSelectionBaseSyncHistoryContent = _resolveComponent("ProductSelectionBaseSyncHistoryContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseTitle, {
      title: _ctx.$t('synchronisationHistory'),
      mb: 3
    }, {
      buttons: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.reloadContent && _ctx.reloadContent(...args)), ["prevent"])),
          class: "btn btn-hover"
        }, _hoisted_2),
        _createVNode(_component_base_modal_button, {
          mode: "close",
          class: "btn-close",
          "aria-label": "Close"
        })
      ]),
      _: 1
    }, 8, ["title"]),
    (_openBlock(), _createBlock(_component_ProductSelectionBaseSyncHistoryContent, {
      "external-system-type-code": _ctx.externalSystemTypeCode,
      key: _ctx.contentKey
    }, null, 8, ["external-system-type-code"]))
  ], 64))
}